import type { UpdatePaymentRequest } from '../../../generated-types';
import nullableZonedDateToUtc from '../../../utils/mapper/nullableZonedDateToUtc';
import { PaymentState } from '../../transaction/Payment/form/state';

export default (paymentState: PaymentState) => {
    const request: UpdatePaymentRequest = {
        paymentType: 'PAYMENT',
        amount: paymentState.amount || 0,
        currency: 'NOK',
        fromAccountNumber: paymentState.fromAccount!,
        paymentDate: nullableZonedDateToUtc(paymentState.paymentDate)!,
        toAccount: paymentState.toAccount!.accountNumber,
        text: paymentState.note ?? undefined,
        ownText: paymentState.ownText,
        kid: paymentState.kid,
        deviceId: window.ReactNativeProps?.deviceId,
    };

    return request;
};
